import Api from "./Api";

export default {
    getAllClientMomList(payload) {
        let AllClientUserList = Api().post(
            "Api_Dashboard/getAllCSODash.php",
            payload
        );
        return AllClientUserList;
    },
 

};



// WEBPACK FOOTER //
// ./src/services/ClientMomService.js